import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import apiService from '../../services/apiServices';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from 'react-router-dom';

export default function AddSalary() {
  //const classes = useStyles();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [workers, setWorkers] = useState([]);
  const [months, setMonths] = useState([]);
  const [worker, setWorker] = useState([]);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();
  let { testvalue } = useParams();

  useEffect(() => {
    apiService()
      .get('selectworker')
      .then((response) => {
        if (response.success) {
          setWorkers(response.data);
          console.log('worker:', response.data);
        } else {
          alert('Error:' + response.errorMessage);
        }
      });
    apiService()
      .get('months')
      .then((response) => {
        if (response.success) {
          setMonths(response.data);
          //console.log(response.data);
        } else {
          alert('Error:' + response.errorMessage);
        }
      });

    console.log('sssa', testvalue)
  }, []);

  const onSubmit = (data) => {
    data.WorkerId = data.WorkerId.id;
    data.Month = data.Month.id;
    console.log(data);
    apiService()
      .post('salaries', data)
      .then((response) => {
        console.log('resp: ', response)
        if (response.success) {
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };
  const paymentType = [
    { id: 0, name: 'Kesh' },
    { id: 1, name: 'Banke' },
  ];

  function handleChange(event, a) {
    console.log('h: ', { ...register('WorkerId') });
  }

  function salary(user) {
    apiService()
      .query('getWorker', 'id=' + user.id)
      .then((response) => {
        console.log('response', response)
        if(response.success && response.data.length > 0) {
          let w = response.data[0]
          setWorker(w)
          setValue('Salary', w.BaseSalary ? w.BaseSalary : 0)
          setValue('HourSalary', w.HourSalary ? w.HourSalary : 0)
        }
        else {
          setValue('Salary', 0)
          setValue('HourSalary', 0)
        }
    });
  }

  const total = (name, value) => {
    let s = watch("Salary") ? parseFloat(watch("Salary")) : 0
    let a = watch("Advances") ? parseFloat(watch("Advances")) : 0 
    let hs = watch("HourSalary") ? parseFloat(watch("HourSalary")) : 0 
    let b = watch("Bonus") ? parseFloat(watch("Bonus")) : 0 
    console.log(s, a, hs, b)
    return s+hs+b-a
  }

  const calculateExtraHours = (e) => {
    if(e.target.value) {
      setValue('HourSalary', worker.HourSalary*watch('ExtraHours'))
    }
    else{
      setValue('HourSalary', worker.HourSalary)
    }
  }

  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/salarieslist/addsalary"
          save={handleSubmit(onSubmit)}
        />
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Paga e punetorit
            </Typography>
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={3} lg={4}>
                  <SelectController
                    onChangeProp={handleChange}
                    salary={salary}
                    placeholder="Punetori"
                    error={errors.WorkerId}
                    control={control}
                    options={workers}
                    name="WorkerId"
                    register={{ ...register('WorkerId') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Muaji"
                    error={errors.Month}
                    control={control}
                    options={months}
                    name="Month"
                    register={{ ...register('Month') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Data"
                    error={errors.SalaryDate}
                    control={control}
                    type="date"
                    register={{ ...register('SalaryDate') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={2}>
                  <SelectController
                    placeholder="Menyra e pageses"
                    error={errors.PaymentType}
                    control={control}
                    options={paymentType}
                    name="PaymentType"
                    register={{ ...register('PaymentType') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={2}>
                  <InputController
                    placeholder="Paga"
                    error={errors.Salary}
                    control={control}
                    symbol="€"
                    //total={total}
                    register={{ ...register('Salary') }}
                    //changeHandler={total}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={2}>
                  <InputController
                    placeholder="Avanci"
                    error={errors.Advances}
                    control={control}
                    symbol="€"
                    register={{ ...register('Advances') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={2}>
                  <InputController
                    placeholder="Orët shtesë"
                    error={errors.ExtraHours}
                    control={control}
                    register={{ ...register('ExtraHours') }}
                    changeHandler={calculateExtraHours}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={2}>
                  <InputController
                    placeholder="Pagesa për Orë shtesë"
                    error={errors.HourSalary}
                    control={control}
                    symbol="€"
                    register={{ ...register('HourSalary') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={2}>
                  <InputController
                    placeholder="Bonuset"
                    error={errors.Advances}
                    control={control}
                    symbol="€"
                    register={{ ...register('Bonus') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={2}>
                  <InputController
                    placeholder="Totali"
                    error={errors.Totali}
                    control={control}
                    symbol="€"
                    value={total()}
                    register={{ ...register('Totali') }}
                  />
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
